import React from 'react';
import { connect } from 'react-redux';
import { Grid, Col, Row } from 'react-bootstrap';
import { SelectSearchContainer } from '../../components/shared';
import { Loading } from '../../components/shared';
import { getSubmission } from '../api';
import { submission as submissionUtils } from '../../utils';
import { updateManualQuoteStatus } from '../actions';

export const QUOTE_STATUS_DECLINED = 'DECLINED';
export const QUOTE_STATUS_BOUND_MANUAL = 'BOUNDMANUAL';

export const MANUAL_QUOTE_STATUS_OPTIONS = [
    {
        display: 'Bound',
        code: QUOTE_STATUS_BOUND_MANUAL
    },
    {
        display: 'Declined',
        code: QUOTE_STATUS_DECLINED
    }
];

class ChangeQuoteStatusModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            manualQuoteStatus: '',
            manualQuoteStatusUpdatedAt: null,
            primaryPolicyNumber: undefined,
            selectedSubmission: null,
            enableSave: false,
            loading: false,
            saveLoading: false,
            hasExpired: false,
            showPolicyNumber: false,
            validationMessages: [],
            statusOptionsList: [],
            declineComment: undefined,
        };
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handlePolicyNumberChange = this.handlePolicyNumberChange.bind(this);
        this.validateSuccess = this.validateSuccess.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDeclineComment = this.handleDeclineComment.bind(this);
        this.handleDeclineCommentOnBlur = this.handleDeclineCommentOnBlur.bind(this);
    }

    componentDidMount = () => {
        this.setState(
            {
                loading: true
            },
            async () => {
                try {
                    const res = await getSubmission(this.props.user, {
                        id: this.props.selectedSubmissionRow
                    });
                    if (res.data) {
                        let primaryPolicyNumber;
                        let declineComment;
                        let showPolicyNumber = false;

                        // populate primaryPolicyNumber logic
                        if (
                            res.data.primaryPolicyNumber &&
                            (res.data.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL ||
                                (this.props.isBound &&
                                    res.data.manualQuoteStatus !== QUOTE_STATUS_DECLINED))
                        ) {
                            primaryPolicyNumber = res.data.primaryPolicyNumber.trim();
                        } else if (res.data.primaryPolicyNumber !== undefined) {
                            primaryPolicyNumber = '';
                        }

                        // populate Decline Comment logic
                        if (res.data.declineComment && res.data.manualQuoteStatus === QUOTE_STATUS_DECLINED) {
                            declineComment = res.data.declineComment.trim();
                        } else if (res.data.declineComment !== undefined) {
                            declineComment = '';
                        }

                        // set showPolicyNumber logic
                        if (
                            res.data.manualQuoteStatus === QUOTE_STATUS_BOUND_MANUAL ||
                            (this.props.isBound &&
                                res.data.manualQuoteStatus !== QUOTE_STATUS_DECLINED)
                        ) {
                            showPolicyNumber = true;
                        }
                        const statusOptionsList =
                            this.props.isBound &&
                            res.data.manualQuoteStatus !== QUOTE_STATUS_BOUND_MANUAL
                                ? MANUAL_QUOTE_STATUS_OPTIONS.filter(
                                      item => item.code !== QUOTE_STATUS_BOUND_MANUAL
                                  )
                                : MANUAL_QUOTE_STATUS_OPTIONS;
                        this.setState({
                            selectedSubmission: res.data,
                            manualQuoteStatus: res.data.manualQuoteStatus
                                ? res.data.manualQuoteStatus.trim()
                                : '',
                            manualQuoteStatusUpdatedAt: res.data.manualQuoteStatusUpdatedAt,
                            primaryPolicyNumber: primaryPolicyNumber,
                            statusOptionsList: statusOptionsList,
                            showPolicyNumber: showPolicyNumber,
                            enableSave: true,
                            loading: false,
                            declineComment: declineComment
                        });
                    }
                } catch (e) {
                    console.error(e.message);
                }
            }
        );
    };

    componentDidUpdate = prevProps => {
        if (this.props.loading === false && prevProps.loading === true) {
            this.setState({
                saveLoading: false,
                enableSave: true
            });
        }
    };

    handleStatusChange = selectedOption => {
        if (selectedOption && selectedOption.value === QUOTE_STATUS_BOUND_MANUAL) {
            this.setState({
                manualQuoteStatus: selectedOption.value,
                showPolicyNumber: true,
                declineComment: ''
            });
        } else {
            let showPolicyNumber = false;
            if (
                this.props.isBound &&
                (!selectedOption || selectedOption.value !== QUOTE_STATUS_DECLINED)
            ) {
                showPolicyNumber = true;
            }
            this.setState({
                manualQuoteStatus:
                    selectedOption && selectedOption.value ? selectedOption.value : '',
                showPolicyNumber: showPolicyNumber,
                primaryPolicyNumber: '',
                declineComment:''
            });
        }
    };

    handlePolicyNumberChange = event => {
        let value = '';
        if (typeof event.target.value === 'string') {
            value = event.target.value.trim();
        }
        this.setState({
            primaryPolicyNumber: value
        });
    };

    handleDeclineComment = event => {
        let value = '';
        if (typeof event.target.value === 'string') {
            value = event.target.value;
        }
        this.setState({
            declineComment: value
        });
    }

    handleDeclineCommentOnBlur = event => {
        let value = '';
        if (typeof event.target.value === 'string') {
            value = event.target.value.trim();
        }
        this.setState({
            declineComment: value
        });
    }

    validateSuccess = () => {
        let validationFailed = false;
        let validationMessages = [];
        // Check Declined 90 Day rule.
        if (
            this.state.selectedSubmission.manualQuoteStatus === QUOTE_STATUS_DECLINED &&
            this.state.selectedSubmission.manualQuoteStatusUpdatedAt &&
            submissionUtils.hasExpired(this.state.selectedSubmission.manualQuoteStatusUpdatedAt, 90)
        ) {
            validationMessages.push({
                key: 'DECLINE_90DAYS',
                message: 'Cannot change Declined status after 90 days.'
            });
            validationFailed = true;
        }
        this.setState({
            validationMessages: validationMessages
        });
        return !validationFailed;
    };

    handleSave = event => {
        event.preventDefault();
        if (this.validateSuccess() && this.state.selectedSubmission !== null) {
            this.setState(
                {
                    saveLoading: true,
                    enableSave: false
                },
                () => {
                    let payload = {
                        manualQuoteStatus: this.state.manualQuoteStatus,
                        manualQuoteStatusUpdatedAt: new Date().toISOString()
                    };
                    payload =
                        this.state.primaryPolicyNumber !== undefined
                            ? { ...payload, primaryPolicyNumber: this.state.primaryPolicyNumber, declineComment: this.state.declineComment }
                            : payload;
                    /**
                     * The call to updateManualQuoteStatus ends up populating the manualQuoteStatusUpdatedList array in redux.
                     * The submission grid in SubmissionsListFeedTable component uses this array to determine
                     * what the manualQuoteStatus value is as the grid can sometimes load before elastic search is updated
                     * so the UI would not show the correct manualQuoteStatus value without the manualQuoteStatusUpdatedList
                     * array.
                     */
                    this.props.updateManualQuoteStatus(
                        this.state.selectedSubmission.id,
                        payload,
                        this.props.user,
                        this.props.refetchSubmissions
                    );
                }
            );
        }
    };

    render() {
        return (
            <div>
                {this.state.loading && (
                    <div className="modal-loader">
                        <Loading width="44px" height="44px" />
                    </div>
                )}
                {!this.state.loading && (
                    <div className="modal-main">
                        <Grid fluid={true}>
                            <Row>
                                <Col xs={12} md={6}>
                                    <label className="input-label">
                                        Additional Status Options:
                                    </label>
                                    <div>
                                        <SelectSearchContainer
                                            options={this.state.statusOptionsList}
                                            labelColumn={'display'}
                                            valueColumn={'code'}
                                            value={this.state.manualQuoteStatus}
                                            onChange={this.handleStatusChange}
                                            id="manualQuoteStatusDropdownEdit"
                                            placeHolder="Select status..."
                                        /><br />
                                         {this.state.manualQuoteStatus=== QUOTE_STATUS_DECLINED &&(
                                             <div>
                                             <label className="input-label">
                                                 Decline Reason:
                                             </label> <input
                                                type="text"
                                                className="text-input2"
                                                onChange={this.handleDeclineComment}
                                                onBlur={this.handleDeclineCommentOnBlur}
                                                placeholder='Optional'
                                                value={this.state.declineComment || ''}
                                         /></div>)}
                                    </div>
                                    {this.state.showPolicyNumber && (
                                        <div>
                                            <label className="input-label">
                                                Primary Policy Number:
                                            </label>
                                            <input
                                                type="text"
                                                className="text-input2"
                                                onChange={this.handlePolicyNumberChange}
                                                value={this.state.primaryPolicyNumber || ''}
                                            />
                                        </div>
                                    )}
                                    <button
                                        className="btn-default btn save-button2"
                                        onClick={this.handleSave}
                                        disabled={!this.state.enableSave}
                                    >
                                        Save
                                    </button>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6}>
                                    {this.state.saveLoading && (
                                        <div>
                                            <Loading width="22px" height="22px" />
                                        </div>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} md={6}>
                                    <div className="notification-text">
                                        {this.state.validationMessages.map(items => (
                                            <div key={items.key} className="error-text">
                                                {items.message}
                                            </div>
                                        ))}
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={12} md={6}>
                                    <button
                                        className="btn-link close-button"
                                        onClick={this.props.onHide}
                                    >
                                        Close and return to submissions
                                    </button>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user
});

const connectedChangeQuoteStatusModal = connect(
    mapStateToProps,
    { updateManualQuoteStatus }
)(ChangeQuoteStatusModal);

export { connectedChangeQuoteStatusModal as ChangeQuoteStatusModal };
